var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApplicationForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8a2 2 0 012-2h10a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V8z",
    fill: "#C2B6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3a2 2 0 00-2 2h9a2 2 0 012 2v12h1a2 2 0 002-2V5a2 2 0 00-2-2H9z",
    fill: "#6244FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 10A.75.75 0 016 9.25h8a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75zM5.25 13a.75.75 0 01.75-.75h5a.75.75 0 010 1.5H6a.75.75 0 01-.75-.75z",
    fill: "#6244FF"
  })));
}

export default SvgApplicationForm;